

// const baseURL = "http://localhost:5001/imbored-1bd79/us-central1";

 const baseURL = "https://us-central1-imbored-1bd79.cloudfunctions.net/";


export default baseURL;